interface IBGCircle {
  bgColor?: string;
  diameterPX?: number | null;
  position: {
    top?: number | string;
    left?: number | string;
    bottom?: number | string;
    right?: number | string;
  };
  sx?: any;
}

export const BGCircle = (props: IBGCircle) => (
  <div
    style={{
      position: 'absolute',
      background: props.bgColor ? props.bgColor : '#F2F7FF',
      borderRadius: '50%',
      zIndex: '0',
      width: props.diameterPX ? `${props.diameterPX}px` : '215px',
      height: props.diameterPX ? `${props.diameterPX}px` : '215px',
      top: props.position.top,
      left: props.position.left,
      bottom: props.position.bottom,
      right: props.position.right,
      ...props.sx,
    }}
  />
);
